import React from 'react';

import { globalTranslationKeys } from '../../../enums';
import { marketTypes } from '../../../helpers/constants';
import { soundService, soundTypes } from '../../../services';

const UnderOverSection = ({ t, marketType, setMarketType }) => {
  return (
    <div className='monti-bet-actions-buttons'>
      <div
        className={`monti-bet-action-button under ${!marketType ? 'selected' : ''}`}
        onClick={() => {
          soundService.play(soundTypes.clickButton);
          setMarketType(marketTypes.Under);
        }}
      >
        <div className='monti-bet-action-button-inside'>
          <div className='monti-bet-action-button-inner'>
            <i className='ui-lib-under-arrow' />
            <span>{t(globalTranslationKeys.Under)}</span>
          </div>
        </div>
      </div>
      <div
        className={`monti-bet-action-button over ${marketType ? 'selected' : ''}`}
        onClick={() => {
          soundService.play(soundTypes.clickButton);
          setMarketType(marketTypes.Over);
        }}
      >
        <div className='monti-bet-action-button-inside'>
          <div className='monti-bet-action-button-inner'>
            <i className='ui-lib-over-arrow' />
            <span>{t(globalTranslationKeys.Over)}</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UnderOverSection;
